<template>
    <div class="container">
        <div class="content">
            <div class="tab-box">
                <img class="top-img" :src="`${imgUrl}/register/7.png`" />
                <div class="tab">
                    <div
                        class="tab-item"
                        :class="{ 'tab-item__active': tabIndex === curIndex }"
                        v-for="(tab, tabIndex) in tabs"
                        @click="onTabClick(tabIndex)"
                        :key="tab.id">{{ tab.name }}</div>
                </div>
            </div>
            <div class="gap" />
            <section v-show="curIndex === 0" class="intro-box">
                <div class="btn-box">
                    <img class="btn-img" :src="`${imgUrl}/register/1.png`" />
                    <div :class="[fixedBtn ? 'fixed-btn' : 'submit-btn']">
                        <div class="btn-animate btn" @click="openShop">点击立刻0元开通</div>
                        <img class="finger-img pointer-move" src="../../assets/finger.png" />
                    </div>
                </div>
                <img class="intro-img" :src="`${imgUrl}/register/2.png`" />
                <img class="img" :src="`${imgUrl}/register/3.png`" />
                <div class="store-show">
                    <div class="show-box">
                        <img class="icon" src="../../assets/store-title_icon.png" />
                        <img class="show-img" :src="`${imgUrl}/common/yym.png`" />
                    </div>
                </div>
                <img class="desc-img" :src="`${imgUrl}/register/4.png`" />
                <div class="store-show pb-15">
                    <div class="show-box">
                        <img class="icon" src="../../assets/store-title_icon.png" />
                        <img class="show-img" :src="`${imgUrl}/common/hfx.png`" />
                    </div>
                </div>
            </section>
            <section class="join-box" v-show="curIndex === 1">
                <!-- <img class="join-img" :src="`${imgUrl}/register/6.png`" /> -->
                <div class="linkage-count">
                    <img class="linkage-img" src="http://image.jxt1314.com/h5/register/11.jpg" />
                    <div :class="[fixeLinkage ? 'fixed-linkage' : 'linkage-btn']">
                        <div class="linkage-box btn-animate" @click="openService">
                            <span>点击注册</span>
                            <div class="container">
                                <div class="dot"></div>
                                <div class="pulse"></div>
                                <div class="pulse1"></div>
                            </div>
                        </div>
                        <img class="finger-img pointer-move" src="../../assets/finger.png" />
                    </div>
                    <img class="linkage-img" src="http://image.jxt1314.com/h5/register/12.jpg" />
                    <img class="linkage-img" src="http://image.jxt1314.com/h5/register/13.jpg" />
                    <img class="linkage-img" src="http://image.jxt1314.com/h5/register/14.jpg" />
                </div>
            </section>
            <section class="join-box" v-show="curIndex === 2">
                <img class="join-img" src="https://image.jxt1314.com/h5/register/6.png" />
                <div :class="[fixed ? 'fixed-btn' : 'join-btn-box']">
                    <div class="btn-animate join-btn" @click="openService">「点击注册」限时0元入驻</div>
                    <img class="finger-img pointer-move" src="../../assets/finger.png" />
                </div>
            </section>
            <section v-show="curIndex === 3" class="service-box">
                <div class="join-guide">
                    <img class="guide-img" style="margin-bottom: 0 !important;" :src="`${imgUrl}/register/8.png`" />
                    <div class="service-btn-box" @click="openService">
                        <div class="service-btn">点击联系客服</div>
                        <img class="service-icon" src="../../assets/service_msg.png" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { ref, computed, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { debounce } from '@/utils/util'
    import { customerService } from "@/utils/getCustomerService"

    export default {
        name: 'register-guide',
        setup() {
            const { proxy } = getCurrentInstance()
            const router = useRouter()
            const curIndex = ref(0)
            const scrollTop = ref(0)
            const offsetTop = ref(0)
            const imgUrl = ref('https://image.jxt1314.com/h5')

            const linkageTop = ref(0)
            const tabs = ref([
                {
                    id: 0,
                    name: '门店老板'
                },
                {
                    id: 3,
                    name: '连锁老板'
                },
                {
                    id: 1,
                    name: '服务商老板'
                },
                {
                    id: 2,
                    name: '我是员工'
                }
            ])

            const onTabClick = (index) => {
                curIndex.value = index
            }

            const openShop = () => {
                router.push({
                    path: '/shop',
                    query: {
                        linkCode: 1,
                        regCode: 2
                    }
                })
            }

            const fixedBtn = computed(() => scrollTop.value > 250)
            const fixed = computed(() => offsetTop.value > 225)
            const fixeLinkage = computed(() => linkageTop.value > 206)
            const openService = () => {
                proxy.$http.post('/base/kefu').then(({ data: res }) => {
                    if (res?.success) {
                        customerService(res.data)
                    } else {
                        proxy.$toast(res.errorMessage)
                    }
                }).catch(err => console.log('err', err))
            }

            onMounted(() => {
                window.addEventListener('scroll', debounce(() => {
                    if (curIndex.value === 0) {
                        scrollTop.value = window.scrollY
                    }
                    if (curIndex.value === 1) {
                        linkageTop.value = window.scrollY
                    }

                    if (curIndex.value === 2) {
                        offsetTop.value = window.scrollY
                    }

                }, 30))
            })

            onBeforeUnmount(() => {
                window.removeEventListener('scroll', () => {})
            })

            return {
                curIndex,
                tabs,
                scrollTop,
                offsetTop,
                linkageTop,
                fixedBtn,
                fixed,
                imgUrl,
                fixeLinkage,
                openService,
                onTabClick,
                openShop
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 375px;
        margin: auto;
        .close-icon {
            position: fixed;
            top: 65px;
            right: 10px;
            z-index: 999;
        }
        .gap {
            height: 162px;
        }
        .content {
            border-radius: 20px 20px 0 0;
            padding-bottom: 80px;
            overflow: hidden;

            .fixed-btn {
                background: #fff;
                width: 375px;
                height: 80px;
                position: fixed;
                left: 50%;
                bottom: 0;
                z-index: 1000;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(-50%);
            }

            .linkage-count {
                position: relative;
            }

            .fixed-linkage {
                background: #fff;
                width: 375px;
                height: 80px;
                position: fixed;
                left: 50%;
                bottom: 0;
                z-index: 1000;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(-50%);
            }

            .linkage-btn {
                width: 100vw;
                height: 80px;
                position: fixed;
                left: 0;
                top: 305px;
                z-index: 1000;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .linkage-box {
                width: 311px;
                height: 40px;
                background: linear-gradient(180deg, #8F7971 0%, #342521 100%);
                box-shadow: 0px 3px 6px 1px #D39C66;
                border-radius: 20px;
                opacity: 1;
                border: 2px solid #FFEEDB;
                font-size: 16px;
                font-weight: bold;
                color: #FFE9C9;
                text-align: center;
                line-height: 36px;
                position: relative;
                .circle-3 {
                    width: 10px;
                    height: 10px;
                    border: 1px solid #fff;
                    position: absolute;
                    right: 50px;
                    top: 50%;
                    transform: translateY(-50%);
                    border-radius: 50%;
                    // box-shadow: 0 0 10px #fff, 0 0 14px #fff, 0 0 32px #fff;
                    animation: circle-grow 1500ms linear infinite;
                }
            }
            @keyframes circle-grow {
                0% {
                    width: 0;
                    height: 0;
                    opacity: 1;
                }
                100% {
                    width: 32px;
                    height: 32px;
                    opacity: 0;
                }
            }



            .tab-box {
                width: 375px;
                height: 162px;
                position: fixed;
                left: 50%;
                top: 0;
                z-index: 1000;
                transform: translateX(-50%);

                .tab {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    display: flex;
                    align-items: flex-end;

                    &-item {
                        flex: 1;
                        background: #fff;
                        height: 35px;
                        line-height: 35px;
                        text-align: center;
                        border-radius: 8px 8px 0 0;
                        font-size: 14px;
                        box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.16);
                        color: #666;

                        &__active {
                            height: 40px;
                            line-height: 40px;
                            color: #1030A4;
                            font-weight: bold;
                        }
                    }
                }
            }

            .top-img {
                width: 100%;
                height: 100%;
            }

            .intro-box {
                width: 375px;
                overflow-x: hidden;
                // flex: 1;
                // height: calc(100vh - 162px);
                // padding-bottom: constant(safe-area-inset-bottom);
                // padding-bottom: env(safe-area-inset-bottom);
                // overflow-y: scroll;

                .intro-img {
                    width: 375px;
                    height: 178px;
                }

                .img {
                    margin-top: -5px;
                    width: 375px;
                    height: 391px;
                }

                .pb-15 {
                    padding-bottom: 15px;
                }

                .store-show {
                    background: #FAEFDC;

                    .show-box {
                        border-radius: 0 0 20px 15px;
                        overflow: hidden;
                        margin: -10px auto 0;
                        padding: 15px 0 0;
                        width: 351px;
                        background: #fffbf1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }

                    .show-img {
                        width: 345px;
                        height: 248px;
                    }

                    .icon {
                        width: 136px;
                        height: 14px;
                    }
                }

                .desc-img {
                    margin-top: -5px;
                    width: 375px;
                    height: 837px;
                }
            }

            .join-box {
                // padding-bottom: constant(safe-area-inset-bottom);
                // padding-bottom: env(safe-area-inset-bottom);
                // overflow-y: scroll;
                // flex: 1;
                position: relative;

                .join-btn-box {
                    position: absolute;
                    left: 0;
                    top: 170px;
                    width: 375px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .join-btn {
                    width: 310px;
                    height: 40px;
                    background: linear-gradient(90deg, #58BEFA 0%, #418BF6 100%);
                    border-radius: 20px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    font: {
                        size: 16px;
                        weight: bold;
                    }
                }

                .join-img {
                    width: 375px;
                    height: 846px;
                }
            }

            .service-box {
                // flex: 1;
                // overflow-y: scroll;
                position: fixed;
                left: 50%;
                top: 162px;
                height: calc(100vh - 162px);
                width: 375px;
                padding-top: 20px;
                background: #F6D246;
                transform: translateX(-50%);

                .join-guide {
                    // padding: 0 0 20px;
                    margin: 0 12px;
                    background: #fff;
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .guide-img {
                        margin: 20px 0 35px;
                        width: 323px;
                        //height: 222px;
                    }

                    .service-btn-box {
                        position: relative;
                        bottom: 50px;
                    }

                    .service-btn {
                        width: 310px;
                        height: 40px;
                        background: linear-gradient(90deg, #EB6A4A 0%, #E63B40 100%);
                        box-shadow: 0px 6px 10px 1px #F2C5BE;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font: {
                            size: 16px;
                            weight: bold;
                        }
                    }

                    .service-icon {
                        position: absolute;
                        right: 45px;
                        bottom: 5px;
                        width: 67px;
                        height: 67px;
                    }
                }
            }

            .btn-box {
                position: relative;
                height: 256px;

                .submit-btn {
                    position: absolute;
                    left: 0;
                    bottom: 10px;
                    width: 375px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .btn {
                    position: relative;
                    width: 310px;
                    height: 40px;
                    background: linear-gradient(180deg, #FEE4A0 0%, #FEB75A 100%);
                    border-radius: 20px;
                    color: #D64630;
                    text-align: center;
                    line-height: 40px;
                    font: {
                        size: 16px;
                        weight: bold;
                    }
                }

                .btn-img {
                    position: absolute;
                    left: -3px;
                    top: 0;
                    width: 384px;
                    right: -3px;
                    height: 264px;
                }
            }

            .btn-animate {
                -webkit-animation: scale-btn 1500ms steps(12) infinite;
                animation: scale-btn 1500ms steps(12) infinite;
            }

            .linkage-img {
                width: 100%;
                display: flex;
            }

            @-webkit-keyframes scale-btn {
                0% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                25% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                50% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                75% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @keyframes scale-btn {
                0% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                25% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                50% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                75% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            .finger-img {
                position: absolute;
                bottom: -10px;
                right: 10px;
                width: 75px;
                height: 53px;
            }

            .pointer-move {
                animation-name: bottomMove, rightMove;
                animation-duration: 1500ms;
                animation-iteration-count: infinite;
                -webkit-animation-name: bottomMove, rightMove;
                -webkit-animation-duration: 1500ms;
                -webkit-animation-iteration-count: infinite;
            }

            @keyframes rightMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: 25px;
                    bottom: -5px;
                }
            }

            @keyframes bottomMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: -15px;
                    bottom: -25px;
                }
            }

            @-webkit-keyframes rightMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: 25px;
                    bottom: -5px;
                }
            }

            @-webkit-keyframes bottomMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: -15px;
                    bottom: -25px;
                }
            }
        }
    }


    @keyframes warn {
        0% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.0;
        }
        25% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.1;
        }
        50% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.3;
        }
        75% {
            transform: scale(0.8);
            -webkit-transform: scale(0.8);
            opacity: 0.5;
        }
        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            opacity: 0.0;
            }
    }
    @keyframes warn1 {
        0% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.0;
        }
        25% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0;
        }
        50% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.5;
        }
        75% {
            transform: scale(0.4);
            -webkit-transform: scale(0.4);
            opacity: 0.5;
        }
        100% {
            transform: scale(0.4);
            -webkit-transform: scale(0.4);
            opacity: 0.0;
        }
    }
    @keyframes warn2 {
        0% {
            transform: scale(0.1);
            -webkit-transform: scale(0.1);
            opacity: 0.5;
        }
        25% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.5;
        }
        50% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0;
        }
        75% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.5;
        }
        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            opacity: 0.0;
        }
    }
    /* 保持大小不变的小圆点 */
    .dot {
        position: absolute;
        width: 10px;
        height: 10px;
        right: 54.5px;
        top: 34%;
        transform: translateY(-50%);
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border: 1px solid #ffffff;
        border-radius: 50%;
        // background-color:#33ccff; /* 实心圆 ，如果没有这个就是一个小圆圈 */
        z-index: 2;
        opacity: 0;
        -webkit-animation: warn2 1.5s ease-out;
        -moz-animation: warn2 1.5s ease-out;
        animation: warn2 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
    /* 产生动画（向外扩散变大）的圆圈 第一个圆 */
    .pulse {
        position: absolute;
        width: 35px;
        height: 35px;
        right: 42px;
        top: 0;
        transform: translateY(-50%);
        border: 1px solid #ffffff;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn 1.5s ease-out;
        -moz-animation: warn 1.5s ease-out;
        animation: warn 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
    /* 产生动画（向外扩散变大）的圆圈 第二个圆 */
    .pulse1 {
        position: absolute;
        width: 35px;
        height: 35px;
        right: 42px;
        top: 0;
        transform: translateY(-50%);
        border: 1px solid #ffffff;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn1 1.5s ease-out;
        -moz-animation: warn1 1.5s ease-out;
        animation: warn1 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
</style>
